import type { IdPostAccountDto, IdPostContactDto } from '@/services/ws-post-crm/src/main/resources/rest-api';

export interface AccountDetailsRouteParams {
  accountId: IdPostAccountDto;
}

export interface ContactFormRouteParams {
  contactId?: IdPostContactDto;
}

export enum ContactFormSearchParams {
  ACCOUNT_ID = 'accountId',
  REDIRECT_TO = 'redirectTo',
}

export interface AccountFormRouteParams {
  accountId?: IdPostAccountDto;
}
